import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../account/components/ProtectedRoute";
import { LoginPage } from "../account/pages/LoginPage";
import { AdminAssessmentsPage } from "../admin/pages/AdminAssessmentsPage";
import { AdminPlayersPage } from "../admin/pages/AdminPlayersPage";
import { PlayerReportPage } from "../dashboard/pages/PlayerReportPage";
import { CoachLayout } from "./components/CoachLayout";
import { CoachDashboardPage } from "./pages/CoachDashboardPage";
import { CoachSchedulePage } from "./pages/CoachSchedulePage";
import { CoachSettingsPage } from "./pages/CoachSettingsPage";

export function CoachRoutes() {
  return (
    <Routes>
      <Route path="/coach/login" element={<LoginPage portal="coach" />} />
      <Route
        path="/coach"
        element={
          <ProtectedRoute allow={["coach"]}>
            <CoachLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<CoachDashboardPage />} />
        <Route path="schedule" element={<CoachSchedulePage />} />
        <Route path="assessments" element={<AdminAssessmentsPage />} />
        <Route path="players" element={<AdminPlayersPage />} />
        <Route path="players/:playerId/report" element={<PlayerReportPage />} />
        <Route path="settings" element={<CoachSettingsPage />} />
        <Route path="*" element={<CoachDashboardPage />} />
      </Route>
    </Routes>
  );
}
